import { render, staticRenderFns } from "./MeasurementNotesCard.vue?vue&type=template&id=602593ae"
import script from "./MeasurementNotesCard.vue?vue&type=script&lang=js"
export * from "./MeasurementNotesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports